import React, { useState, useEffect } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Paper from '@material-ui/core/Paper';
import Grid from '@material-ui/core/Grid';
import Tabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';
import PropTypes from 'prop-types';
import Person from '../../Icons/Person';
import Building from '../../Icons/Building';
import SlideOneCard from '../../slideOneCard';
import ButtonNormal from '../../Buttons/ButtonNormal';
import HeaderSection from '../HeaderSection/HeaderSection';
import LegalMatterCard from '../../Cards/LegalMatterCard';
import {
  getLegalMattersByCategory,
  getLegalMattersByFilter,
} from '../../../store/actions/LegalMatterActions';
import { showLoading, hideLoading } from '../../../store/actions/LoadingActions';
import { connect } from 'react-redux';
import { useHistory } from 'react-router-dom';
import * as ROUTES from '../../../routes';
import './Guides.scss';

function a11yProps(index) {
  return {
    id: `nav-tab-${index}`,
    'aria-controls': `nav-tabpanel-${index}`,
  };
}

function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      key={index}
      component="div"
      role="tabpanel"
      hidden={value !== index}
      id={`nav-tabpanel-${index}`}
      aria-labelledby={`nav-tab-${index}`}
      {...other}
    >
      {value === index && <>{children}</>}
    </div>
  );
}

TabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.any.isRequired,
  value: PropTypes.any.isRequired,
};

const useStyles = makeStyles((theme) => ({
  tabsFlexContainer: {
    '@media(max-width: 768px)': {
      padding: 0,
    },
  },
  tab: {
    textTransform: 'initial',
    fontSize: 16,
    '@media(max-width: 768px)': {
      width: '50%',
    },
  },
  tabSelected: {
    fontWeight: 'bold',
  },
  labelIcon: {
    minHeight: 64,
  },
  tabWrapper: {
    '&>:first-child': {
      marginRight: 14,
    },
    flexDirection: 'row',
  },
  paper: {
    padding: '0 40px 0',
    textAlign: 'center',
    color: theme.palette.text.secondary,
    '@media(max-width: 768px)': {
      padding: 0,
    },
  },
  item: {
    maxWidth: 368,
    height: 320,
    padding: '24px 32px 32px',
    alignItems: 'flex-start',
  },
  grid: {
    '@media screen and (max-width: 768.98px)': {
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
    },
  },
}));

const styles = {
  dotStyles: {
    height: 18,
    width: 18,
    cursor: 'pointer',
    border: 0,
    background: 'none',
    padding: 3,
    margin: 8,
    outline: 'none',
  },
};

const Guides = ({
  setDataToFetch,
  getLegalMattersByCategory,
  getLegalMattersByFilter,
  legalMattersByCategory,
}) => {
  const classes = useStyles();
  const history = useHistory()
  const [value, setValue] = useState(0);

  const handleChange = (event, newValue) => {
    getLegalMattersByCategory(newValue === 0 ? 'Personas' : 'Empresas');
    setValue(newValue);
  };

  const handleClick = () => {
    history.push(`${ROUTES.LEGAL_MATTERS}`)
    window.scrollTo(0, 0);
  };

  const handleSelectLegalMatter = (legalMatter, id) => {
    setDataToFetch(legalMatter);
    history.push(`${ROUTES.LEGAL_MATTERS}/${legalMatter.category}/${id}`)
    window.scrollTo(0, 0);
    hideLoading()
  };

  const [didGet, setDidGet] = useState(false);

  useEffect(() => {
    if (!didGet) {
      getLegalMattersByCategory(value === 0 ? 'Personas' : 'Empresas');
      setDidGet(true);
    }
  }, [didGet, getLegalMattersByCategory, value])

  

  return (
    <div className="guides">
      <div className="guides_header">
        <HeaderSection
          title="Directorio jurídico más buscado en Contacta Abogado®."
          subtitle={[
            'Las siguientes guías te ayudarán a identificar el asunto en qué necesitas ayuda,',
            <br />,
            'de esta forma podrás encontrar al mejor experto para que te asesore.',
          ]}
        />
      </div>

      <div className="guides_content">
        <Paper className={classes.paper}>
          <Tabs
            value={value}
            onChange={handleChange}
            indicatorColor="primary"
            textColor="primary"
          >
            <Tab
              icon={<Person />}
              label="Particulares"
              classes={{
                root: classes.tab,
                selected: classes.tabSelected,
                labelIcon: classes.labelIcon,
                wrapper: classes.tabWrapper,
              }}
              {...a11yProps(0)}
            />
            <Tab
              icon={<Building />}
              label="Empresas"
              classes={{
                root: classes.tab,
                selected: classes.tabSelected,
                labelIcon: classes.labelIcon,
                wrapper: classes.tabWrapper,
              }}
              {...a11yProps(1)}
            />
          </Tabs>
        </Paper>
        <TabPanel value={value} index={0}>
          <div className="guides_content_panel">
            <Grid container spacing={3} classes={{ root: classes.grid }}>
              {legalMattersByCategory &&
              legalMattersByCategory.data &&
              legalMattersByCategory.data.length !== 0
                ? legalMattersByCategory.data.map((elem, index) => (
                    <Grid key={index} item xs={6} md={4}>
                      <LegalMatterCard
                        containerStyle={classes.item}
                        handleSelectLegalMatter={handleSelectLegalMatter}
                        legalMatterBody={elem}
                        onLanding
                      />
                    </Grid>
                  ))
                : null}
            </Grid>
          </div>
          <div className="guides_content_carousel">
            {legalMattersByCategory &&
              legalMattersByCategory.data &&
              legalMattersByCategory.data.length !== 0 ? (
                <SlideOneCard numberDots={9} dotStyles={styles.dotStyles}>
                  {legalMattersByCategory.data.map((elem, index) => {
                    return (
                      <LegalMatterCard
                        key={index}
                        containerStyle={classes.item}
                        handleSelectLegalMatter={handleSelectLegalMatter}
                        legalMatterBody={elem}
                        onLanding
                      />
                    );
                  })}
                </SlideOneCard>
              ) : null}
          </div>
        </TabPanel>
        <TabPanel value={value} index={1}>
          <div className="guides_content_panel">
            <Grid container spacing={3} classes={{ root: classes.grid }}>
              {legalMattersByCategory &&
              legalMattersByCategory.data &&
              legalMattersByCategory.data.length !== 0
                ? legalMattersByCategory.data.map((elem, index) => (
                    <Grid key={index} item xs={6} md={4}>
                      <LegalMatterCard
                        containerStyle={classes.item}
                        handleSelectLegalMatter={handleSelectLegalMatter}
                        legalMatterBody={elem}
                        onLanding
                      />
                    </Grid>
                  ))
                : null}
            </Grid>
          </div>
          <div className="guides_content_carousel">
            {legalMattersByCategory &&
              legalMattersByCategory.data &&
              legalMattersByCategory.data.length !== 0 ? (
                <SlideOneCard numberDots={9} dotStyles={styles.dotStyles}>
                  {legalMattersByCategory.data.map((elem, index) => {
                    return (
                      <LegalMatterCard
                        key={index}
                        containerStyle={classes.item}
                        legalMatterBody={elem}
                        handleSelectLegalMatter={handleSelectLegalMatter}
                        onLanding
                      />
                    );
                  })}
                </SlideOneCard>
              ) : null}
          </div>
        </TabPanel>
      </div>

      <div className="guides_button">
        <span onClick={handleClick}>Ver todos</span>
      </div>
    </div>
  );
};

const mapStateToProps = (state) => ({
  legalMattersByCategory: state.LegalMatterReducer.legalMatterListByCategory,
});

const mapDispatchToProps = (dispatch) => ({
  getLegalMattersByCategory: (category) =>
    dispatch(getLegalMattersByCategory(category)),
  getLegalMattersByFilter: (params) =>
    dispatch(getLegalMattersByFilter(params)),
});

export default connect(mapStateToProps, mapDispatchToProps)(Guides);
